<template>
  <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
    <div class="">
      <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
        <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
        <span @click="removeChip('Date')"><i class="pi pi-times"></i> </span>
      </div>
      <div class="filter_chip" v-if="filterItemsArray[0]['Code'] !== ''">
        <span>PO code: {{ filterItemsArray[0]["Code"] }}</span>
        <span @click="removeChip('Code')"><i class="pi pi-times"></i> </span>
      </div>
      <div class="filter_chip" v-if="filterItemsArray[0]['FromStore'] != ''">
        <span>Supplier Name: {{ filterItemsArray[0]["FromStore"] }}</span>
        <span @click="removeChip('FromStore')"><i class="pi pi-times"></i>
        </span>
      </div>
    </div>
    <div class="">
      <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
        Clear all
      </button>
    </div>
  </div>
  <div class="form-white-bg" v-if="windowWidth > 545">
    <b-row>
      <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
        <b-collapse id="collapse-1" class="mt-2" v-model="visible">
          <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
            :ClearDateFilter="SearchValue" v-if="FilterLoading">
            <template v-slot:filterslot>
              <itemIssueGrnReturnFilters :storedd="true" @suppliersename="EmitFromStore" @supplierseid="EmitFromStoreId"
                @updatedcode="Emitcode" :removechiptype="removechipvalue" :itemsList="items" />
            </template>
          </FilterForm>
        </b-collapse>
      </b-col>
      <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty :createline="IsAddButton && IssueType != 'InBound'" v-if="
            items.length === 0 &&
            !SearchValue.inputValue &&
            !SearchValue.fromDate &&
            !SearchValue.toDate
          " eheader="Issue Return" econtent="Issue Return" eimg="/src/assets/Img/icons/itemmaster.svg"
            @createNew="IsCreate" />
          <Tableview v-if="
            items.length !== 0 ||
            SearchValue.inputValue ||
            SearchValue.fromDate ||
            SearchValue.toDate
          " :value="items" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true"
            filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
            :globalFilterFields="globalFilterFields" :filters="filters" :state="state" @ShowRows="ShowRows"
            :totalRecords="rowsCount" @row-click="RowClick" :searchbox="false" :searchbox1="true" @search="SearchBox"
            :filterbtn="true" :exceldownload="true" :showColumnFilters="false">
            <template v-slot:filter>
              <i class="pi pi-filter tablefilter ms-2" :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible"></i>
            </template>

            <template v-slot:exceldownload>
              <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                :PageName="exportpagename" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
            </template>
            <template v-slot:Add v-if="IsAddButton && IssueType != 'InBound'">
              <span class="add">
                <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')">
                </AddButton>
              </span>
            </template>
            <template v-slot:action="{ data }">
              <!-- v-if="IssueType == 'OutBound'" -->
              <span>
                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                  @click="toggle($event, data)" />
              </span>
            </template>
          </Tableview>
        </div>
      </b-col>
    </b-row>
  </div>
  <div v-if="windowWidth <= 545">
    <MobileLoader v-if="loading" v-for="item in 5" />
    <div v-if="!loading">
      <MasterEmpty :createline="false" v-if="
        items.length === 0 &&
        !SearchValue.inputValue &&
        !SearchValue.fromDate &&
        !SearchValue.toDate
      " eheader="Issue Return" econtent="Issue Return" eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="" />
      <MobileViewCardHeader v-else :state="state" :totalRecords="rowsCount" v-if="
        items.length !== 0 ||
        SearchValue.inputValue ||
        SearchValue.fromDate ||
        SearchValue.toDate
      " @search="SearchBox">
        <template v-slot:mobilecard>
          <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-1">
                <p class="light-name">{{ item.DocNo }} /</p>
                <p class="light-name1">{{ item.RefNo }}</p>
              </div>
              <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
            </div>
            <p class="name">{{ item.FromStoreName }}</p>
            <div class="d-flex align-items-center gap-2">
              <p class="light-name">Item count :</p>
              <p class="small-name">{{ item.ItemCount }}</p>
            </div>
          </div>
        </template>
      </MobileViewCardHeader>
    </div>
  </div>

  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(DataEdit)" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(DataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  onUnmounted,
} from "vue";

import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../Service/WithoutStockAffectService";
import Service from "../../../../../../modules/Inventory/Service/StockOutService";
import ServiceIn from "../../../../../../modules/Inventory/Service/StockInService";
import { useRoute, useRouter } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import MastersService from "../../../../Service/MastersService";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import itemIssueGrnReturnFilters from "../../../../../../modules/Inventory/components/Filters/itemIssueGrnReturnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../../components/FormComponents/FilterForm.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    itemIssueGrnReturnFilters,
    FilterForm,
    ExportOption,
    CrystalReportPrintPopUp,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    IssueType: {
      type: String,
      default: "",
    },
    propsParams: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ["row-click"],
  setup(props, { emit }) {
    /* variable declaration*/
    const { t } = useI18n();
    const datas = ref();
    const menus = ref();
    const hideAction = props.IssueType == "OutBound" ? false : true;
    let loading = ref(false);
    let showitemfield = ref(false);
    const router = useRouter();
    const generic = ref();
    let items: any = ref([]);
    let loading1 = ref(false);
    let visible = ref(false);
    let exportpagename = ref("");
    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }
    const route = useRoute();
    // let StoreId = route.query.StoreId ?? 0;
    let StoreId = Number(route.query.Id);

    let status = route.query.status ?? 0;
    let Types = route.query.Types;
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    const rowsCount = ref(0);
    const headers = [
      {
        header: t("storetabdetails.issuereturn.sno"),
        field: "RowNumber",
      },
      {
        header: t("storetabdetails.issuereturn.Code"),
        field: "DocNo",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.issuereturn.Date"),
        field: "ReturnDate",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuereturn.ToStore"),
        field: "ToStoreName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.issuereturn.FromStore"),
        field: "FromStoreName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.issuereturn.ItemCount"),
        field: "ItemCount",
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.issuereturn.Returnby"),
        field: "ReturnedByName",
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuereturn.Verifiedby"),
        field: "Verifiedby",
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },

      // {
      //   header: t('storetabdetails.issuereturn.Status'),
      //   field: "",
      //   fieldDisplay: "false",
      //   slot: "ApprovalStatus",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "",
      // },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        // hide: hideAction,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ];

    if (props.IssueType == "OutBound") {
      headers.splice(3, 1);
      const index = 2;

      const pushheader: any = {
        header: "To Store",
        field: "ToStoreName",
        bodyclass: "boldclass",
      };

      headers.splice(index, 0, pushheader);
    }

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        let response;
        if (props.IssueType == "OutBound") {
          const pageNum = state.currentPage;
          const pageSize = state.pageSize;
          const columnName = "StoreId";
          const columnValue = StoreId;
          const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
          const columnValue1 = filterItems.value.fromstoreId
            ? filterItems.value.fromstoreId
            : "";
          const columnName2 = filterItems.value.Code ? "DocNo" : "";
          const columnValue2 = filterItems.value.Code
            ? filterItems.value.Code
            : "";
          const columnName3 = "";
          const columnValue3 = "";
          let Flag = 1,
            searchOption = "";

          if (SearchValue.value.inputValue != "") {
            Flag = 2;
            searchOption = SearchValue.value.inputValue;
          }
          let Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            "  and (COALESCE('" +
            usersData.BranchId +
            "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
            usersData.BranchId +
            "', ',')))";
          response = await Service.listStockOutMasterTM(
            SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
            SearchValue.value.toDate ? SearchValue.value.toDate : "",
            pageSize,
            pageNum,
            "13",
            columnName,
            columnValue,
            columnName1,
            columnValue1,
            columnName2,
            columnValue2,
            columnName3,
            columnValue3,
            "",
            "",
            Flag,
            searchOption,
            Condition
          );
          console.log(response["result"]);
          exportpagename.value = "OutBound Issue Return";
        } else if (props.IssueType == "InBound") {
          const pageNum = state.currentPage;
          const pageSize = state.pageSize;
          const columnName = "StoreId";
          const columnValue = StoreId;
          const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
          const columnValue1 = filterItems.value.fromstoreId
            ? filterItems.value.fromstoreId
            : "";
          const columnName2 = filterItems.value.Code ? "DocNo" : "";
          const columnValue2 = filterItems.value.Code
            ? filterItems.value.Code
            : "";
          const columnName3 = "";
          const columnValue3 = "";
          let Flag = 1,
            searchOption = "";

          if (SearchValue.value.inputValue != "") {
            Flag = 2;
            searchOption = SearchValue.value.inputValue;
          }
          let Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            "  and (COALESCE('" +
            usersData.BranchId +
            "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
            usersData.BranchId +
            "', ',')))";
          response = await ServiceIn.List(
            SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
            SearchValue.value.toDate ? SearchValue.value.toDate : "",
            "13",
            pageNum,
            pageSize,
            columnName,
            columnValue,
            columnName1,
            columnValue1,
            columnName2,
            columnValue2,
            Flag,
            searchOption,
            columnName3,
            columnValue3,
            "",
            "",
            "",
            "",
            "",
            "",
            Condition
          );
          debugger;
          exportpagename.value = "Inbound Issue Return";
        }
        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};
          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field as string];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const rowFocus = ref(false);
    let DataEdit = ref();
    let StockOutTransId = 0;
    let DocType;
    function toggle(event, data) {
      debugger;
      console.log(event);

      datas.value = data;
      // Id.value = event.Id
      menus.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: false,
            command: async () => {
              Editdata(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: false,
            command: async () => {
              Deletedata(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(datas.value);
            },
          },
        ],
      },
    ]);

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
    });


    const PrintType = ref({
      Type: "T",
      FormId: props.IssueType == "InBound" ? 81 : 66,
      HeaderTitle: "Issue Return",
      ModuleId: 3,
    });

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.Id;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    // row click for table
    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      StockOutTransId = event.data
        ? event.data.StockOutTransId
        : event.StockOutTransId;
      DocType = event.data ? event.data.DocType : event.DocType;
      router.push({
        path: "/IssueReturnDetails",
        query: {
          id: event.data ? event.data.Id : event.Id,
          storeid: event.data ? event.data.StoreId : event.StoreId,
          refid: event.data ? event.data.RefId : event.RefId,
          type: props.IssueType == "InBound" ? "Inbound" : "Outbound",
          BranchId: event.data ? event.data.BranchId : event.BranchId,
        },
      });
    }
    function Editdata(data) {
      debugger;
      DataEdit.value = data;
      StockOutTransId = data.StockOutTransId;
      DocType = data.DocType;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      debugger;
      DataEdit.value = data;
      StockOutTransId = data.StockOutTransId;
      DocType = data.DocType;
      Deletemodel.value = true;
    }

    const globalFilterFields = ref(headers.map((col) => col.field));

    let ParamValues = ref({
      StoreId: 0,
      storebranchmapid: 0,
      BranchId: 0,
      EntityId: 0,
      OperationId: 0,
    });

    const IsCreate = () => {
      debugger;
      ParamValues.value.EntityId = 3030;
      ParamValues.value.StoreId = StoreId;
      ParamValues.value.storebranchmapid = Number(route.query.storebranchmapid);
      ParamValues.value.BranchId = Number(route.query.BranchId);;
      router.push({
        path: "/IssueReturnCreation",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "IssueReturn",
        },
      });
    };
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      debugger;
      FunctionRights();

      if (props.IssueType == "OutBound") {
        IsShow();
      } else if (props.IssueType == "InBound") {
        IsShowIn();
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    let dataValue = {
      Id: 0,
      status: 0,
    };

    //Rights Check Based on EntityId
    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        126,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        StoreId = Number(dataValue.Id);
        status = dataValue.status;

        if (props.IssueType == "OutBound") {
          IsShow();
        } else if (props.IssueType == "InBound") {
          IsShowIn();
        }
      }
    });

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        if (props.IssueType == "OutBound") {
          IsShow();
        } else if (props.IssueType == "InBound") {
          IsShowIn();
        }
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        if (props.IssueType == "OutBound") {
          await IsShow();
        } else if (props.IssueType == "InBound") {
          await IsShowIn();
        }
      }
    );

    function IsEdit(DataEdit) {
      debugger;

      console.log(DataEdit["DocNo"]);
      //ParamValues.value.requestId = DataEdit["DocNo"];
      // ParamValues.value.StockOutTransTMId = DataEdit["StockOutTransId"];
      // ParamValues.value.fromStoreId = DataEdit["FromStoreId"];
      // ParamValues.value.toStoreId = DataEdit["ToStoreId"];
      // ParamValues.value.StockTransId = DataEdit["RefId"];
      // ParamValues.value.EntityId = 126;
      // ParamValues.value.OperationId = 450;
      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "IssueReturn",
        },
      });
    }

    // Debounced search for server-side filtering
    function SearchBox(value) {
      debugger;
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      if (props.IssueType == "OutBound") {
        IsShow();
      } else if (props.IssueType == "InBound") {
        IsShowIn();
      }
    }, 300);

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.fromstoreId
          ? filterItems.value.fromstoreId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await Service.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          "13",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          "",
          "",
          Flag,
          searchOption,
          Condition
        );
        console.log(response["result"]);
        items.value = response["result"];

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    async function IsShowIn() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;
        debugger;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.fromstoreId
          ? filterItems.value.fromstoreId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await ServiceIn.List(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          "13",
          pageNum,
          pageSize,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          "",
          "",
          "",
          "",
          "",
          "",
          Condition
        );
        debugger;
        items.value = response["result"];
        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        loading.value = false;
        console.log(items.value);
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    async function IsDelete(DataEdit) {
      debugger;
      console.log(StockOutTransId);
      try {
        const response = await Service.DeleteStockOutTM(StockOutTransId);
        console.log(response["result"]);
        let msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          if (props.IssueType == "OutBound") {
            IsShow();
          } else if (props.IssueType == "InBound") {
            IsShowIn();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    const ParamVal = ref({
      requestId: "",
      StockOutTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 3,
      status: status,
      Types: Types,
    });

    async function IssueReturn(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamVal.value.requestId = data["DocNo"];
      ParamVal.value.StockOutTransTMId = data["StockOutTransId"];
      ParamVal.value.fromStoreId = data["StockOutTransId"];
      ParamVal.value.toStoreId = data["StockOutTransId"];

      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamVal.value),
          param: "IssueReturn",
        },
      });
    }

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      FromStore: "",
      fromstoreId: "",
      Code: "",
    });

    let emitedfilterItems = ref({
      FromStore: "",
      fromstoreId: "",
      Code: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    const EmitFromStore = (data) => {
      emitedfilterItems.value.FromStore = data;
    };

    const EmitFromStoreId = (data) => {
      emitedfilterItems.value.fromstoreId = data;
    };

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      // filterItems.value.LineOfBusiness = ServiceTypeNames;
      // filterItems.value.Type = TaskTypeNames;
      filterItems.value.FromStore = emitedfilterItems.value.FromStore;
      filterItems.value.fromstoreId = emitedfilterItems.value.fromstoreId;
      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.fromstoreId = "";
      filterItems.value.Code = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      if (props.IssueType == "OutBound") {
        IsShow();
      } else if (props.IssueType == "InBound") {
        IsShowIn();
      }
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      // emptyObjectList();
      if (props.IssueType == "OutBound") {
        IsShow();
      } else if (props.IssueType == "InBound") {
        IsShowIn();
      }
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "FromStore") {
        filterItems.value.fromstoreId = "";
        removechipvalue.value = 2;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      if (props.IssueType == "OutBound") {
        IsShow();
      } else if (props.IssueType == "InBound") {
        IsShowIn();
      }
    };

    return {
      showitemfield,
      items,
      headers,
      loading,
      paramValue,
      onRowClick,
      IsShow,
      IsEdit,
      IsDelete,
      IsCreate,
      loading1,
      globalFilterFields,
      filters,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      RowClick,
      DataEdit,
      IssueReturn,
      state,
      rowsCount,
      itemListed,
      menus,
      toggle,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitFromStore,
      EmitFromStoreId,
      Emitcode,
      removeChip,
      removechipvalue,
      SearchBox,
      ShowRows,
      windowWidth,
      visible,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      exportpagename,

      Print,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      hidepopup,
    };
  },
});
</script>
